export default "skymp5-front/9de6882f848b196d76a7f241d40f8a91.jpg";